module.exports = __webpack_public_path__ + "static/img/error.638da60.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/4/error.png
// module id = G72L
// module chunks = 0